<template>
  <div>
    <MainHeader title="Legal">
      <template #left>
        <font-awesome-icon
          :icon="['fas', 'arrow-left-long']"
          class="pointer"
          @click="router.push({ name: 'UserAccount' })"
        />
      </template>
    </MainHeader>

    <div class="view legal-view">
      <div class="legal-header">
        <h1 class="legal-title">Legal Documents</h1>
        <p class="legal-sub">Review our policies and agreements.</p>
      </div>

      <div class="legal-card wrapper-card">
        <span class="section-label">Documents</span>

        <button
          class="legal-row"
          @click="router.push({ name: 'PrivacyPolicy' })"
        >
          <div class="legal-icon-wrap">
            <font-awesome-icon :icon="['fas', 'shield-halved']" />
          </div>
          <span class="legal-row-label">Privacy Policy</span>
          <font-awesome-icon
            :icon="['fas', 'chevron-right']"
            class="legal-chevron"
          />
        </button>

        <button class="legal-row" @click="router.push({ name: 'TermsOfUse' })">
          <div class="legal-icon-wrap">
            <font-awesome-icon :icon="['fas', 'file-lines']" />
          </div>
          <span class="legal-row-label">Terms of Use & Service</span>
          <font-awesome-icon
            :icon="['fas', 'chevron-right']"
            class="legal-chevron"
          />
        </button>

        <button
          class="legal-row"
          @click="router.push({ name: 'EndUserLicense' })"
        >
          <div class="legal-icon-wrap">
            <font-awesome-icon :icon="['fas', 'file-contract']" />
          </div>
          <span class="legal-row-label">End User License Agreement</span>
          <font-awesome-icon
            :icon="['fas', 'chevron-right']"
            class="legal-chevron"
          />
        </button>

        <button
          class="legal-row"
          @click="router.push({ name: 'PlaidEndUser' })"
        >
          <div class="legal-icon-wrap">
            <font-awesome-icon :icon="['fas', 'building-columns']" />
          </div>
          <span class="legal-row-label">Plaid End User Privacy Disclosure</span>
          <font-awesome-icon
            :icon="['fas', 'chevron-right']"
            class="legal-chevron"
          />
        </button>

        <button
          class="legal-row"
          @click="router.push({ name: 'DataDeletion' })"
        >
          <div class="legal-icon-wrap">
            <font-awesome-icon :icon="['fas', 'trash-can']" />
          </div>
          <span class="legal-row-label">Data Deletion Request</span>
          <font-awesome-icon
            :icon="['fas', 'chevron-right']"
            class="legal-chevron"
          />
        </button>
      </div>

      <div class="legal-note wrapper-card mt-2">
        <font-awesome-icon
          :icon="['fas', 'envelope']"
          class="legal-note-icon"
        />
        <p class="legal-note-text">
          Questions? Reach us at <strong>support@luckyfridayapp.com</strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader from '../../components/View-Header.vue';
import { useRouter } from 'vue-router';

export default {
  name: 'UserLegal',
  components: { MainHeader },
  setup() {
    const router = useRouter();
    return { router };
  },
};
</script>

<style scoped>
.legal-view {
  max-width: 480px;
  margin: 0 auto;
}

.legal-header {
  text-align: center;
  padding: 1.5rem 0 1.25rem;
}
.legal-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #004751;
  margin: 0 0 0.3rem;
  letter-spacing: -0.02em;
}
.dark-theme .legal-title {
  color: white;
}
.legal-sub {
  font-size: 0.82rem;
  color: #aaa;
  margin: 0;
}

.legal-card {
  animation: cardSlideUp 0.35s cubic-bezier(0.34, 1.2, 0.64, 1) both;
}

.legal-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  background: none;
  border: none;
  border-bottom: 1px solid #f0f0f0;
  padding: 0.85rem 0;
  cursor: pointer;
  font-family: 'Poppins', sans-serif;
  text-align: left;
  transition: background var(--transition-fast);
  border-radius: 0;
}
.dark-theme .legal-row {
  border-bottom-color: #2a3a4e;
}
.legal-row:last-child {
  border-bottom: none;
}
.legal-row:hover {
  background: #fafafa;
}
.dark-theme .legal-row:hover {
  background: #1a2535;
}

.legal-icon-wrap {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: var(--purple-50);
  color: var(--color-accent-purple);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  flex-shrink: 0;
}
.dark-theme .legal-icon-wrap {
  background: #1e1a40;
}

.legal-row-label {
  flex: 1;
  font-size: 0.88rem;
  font-weight: 500;
  color: #213547;
}
.dark-theme .legal-row-label {
  color: white;
}

.legal-chevron {
  font-size: 0.72rem;
  color: #ccc;
  flex-shrink: 0;
}
.dark-theme .legal-chevron {
  color: #4a5a6e;
}

.legal-note {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 1rem 1.1rem;
}
.legal-note-icon {
  color: #aaa;
  font-size: 0.95rem;
  flex-shrink: 0;
}
.legal-note-text {
  font-size: 0.8rem;
  color: #888;
  margin: 0;
  line-height: 1.5;
}
.dark-theme .legal-note-text {
  color: #888;
}
</style>

<!-- <template>
  <div>
    <MainHeader title="Legal">
      <template #left>
        <font-awesome-icon
          :icon="['fas', 'arrow-left-long']"
          class="pointer"
          @click="router.push({ name: 'UserAccount' })"
        />
      </template>
    </MainHeader>

    <div class="view support-page">
      <button
        class="blue-outline-button w-100 pt-4 pb-4 mb-2"
        @click="router.push({ name: 'PrivacyPolicy' })"
      >
        Privacy Policy
      </button>
      <button
        class="blue-outline-button w-100 pt-4 pb-4 mb-2"
        @click="router.push({ name: 'TermsOfUse' })"
      >
        Terms of use/Terms of Service
      </button>
      <button
        class="blue-outline-button w-100 pt-4 pb-4 mb-2"
        @click="router.push({ name: 'EndUserLicense' })"
      >
        End User License Agreement
      </button>
      <button
        class="blue-outline-button w-100 pt-4 pb-4 mb-2"
        @click="router.push({ name: 'PlaidEndUser' })"
      >
        Plaid End User Privacy Disclosure
      </button>
      <button
        class="blue-outline-button w-100 pt-4 pb-4 mb-2"
        @click="router.push({ name: 'DataDeletion' })"
      >
        Data Deletion Request Information
      </button>

      <div class="wrapper-card closing-text ps-2 pe-2 small-grey-text">
        <div>
          Please reach out to us at support@luckyfridayapp.com with any
          questions.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader from '../../components/View-Header.vue';
import { useRouter } from 'vue-router';

export default {
  name: 'User-Support',
  components: {
    MainHeader,
  },
  setup() {
    const router = useRouter();

    return {
      router,
    };
  },
};
</script>

<style scoped>
.support-page {
  padding: 1em;
  font-size: 1rem;
  line-height: 1.6;
}

.closing-text {
  margin-top: 2em;
  font-style: italic;
}
</style> -->
